<template>
	<div class="content">
		<h1>Shipping details for order {{ getId() }}</h1>
		<OrderShippingEditor class="margin-top" :order="getId()" :autoload="true" />
	</div>
</template>

<script>
export default {
  methods: {
    getId () {
      return this.$route.params.id
    }
  }
}
</script>
